export const SocietyType = {
  LTDA: 'L.T.D.A.',
  SA: 'S.A.',
};
